"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineTotal = void 0;
const roundTo_1 = require("../roundTo");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineTotal = (item) => {
    let total = 0;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return total;
    if (latest_version.status.includes("CANCELLED"))
        return total;
    switch (item.type) {
        case "GOLF": {
            const golf_config = latest_version.config;
            const { green_fee, caddies, carts, where_when_who } = golf_config;
            // Green Fee
            total =
                (green_fee?.cost + green_fee?.margin) *
                    where_when_who?.number_of_golfers +
                    Number(where_when_who.number_of_golfers % 2 ? green_fee?.surcharge || 0 : 0);
            // Caddies
            if (caddies?.total &&
                caddies?.enabled &&
                caddies?.payment_option !== "ON_ARRIVAL") {
                total += caddies?.total;
            }
            // Carts
            if (carts?.enabled && carts?.payment_option !== "ON_ARRIVAL") {
                carts?.types?.map(
                // eslint-disable-next-line array-callback-return
                (cart_type, idx) => {
                    total += cart_type?.total;
                });
            }
            break;
        }
        case "HOTEL": {
            const hotel_config = latest_version.config;
            total = hotel_config.rooms.rooms.reduce((acc, room) => {
                if (!room.total)
                    return acc;
                return acc + room.total;
            }, 0);
            break;
        }
        case "TRANSFER": {
            const transfer_config = latest_version.config;
            if (transfer_config.vehicle)
                total =
                    transfer_config.vehicle.total * transfer_config.vehicle.quantity;
            break;
        }
        case "CUSTOM": {
            const custom_config = latest_version.config;
            total = custom_config?.product_service?.total || 0;
            break;
        }
    }
    return (0, roundTo_1.roundTo)(total, 2);
};
exports.getOrderLineTotal = getOrderLineTotal;
